
//export const baseUrl='';

//export const baseUrl='http://www.jiangoil.com';

//export const wsUrl='ws://wwww.jiangoil.com';

//export const baseUrl='http://localhost:9900';
export const baseUrl='https://iot.jiangoil.cn';

//真知码发码系统测试环境
//export const baseUrl='http://zcode.jiangoil.cn';

//真知码发码系统
//export const baseUrl='http://code.z-code.cn';
